import classnames from "classnames";
import { HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils/genericMemo";
import FooterGroup from "./FooterGroup";

import styles from "../style.module.scss";

type FootersProps<T extends object> = { footerGroups: HeaderGroupType<T>[], className?: string };

const Footers = genericMemo(
  <T extends object>({ footerGroups, className, ...restProps }: FootersProps<T>) => {
    return (
      <div role="rowgroup" className={classnames(className, styles.footerRow)} {...restProps}>
        {
          footerGroups.map(footerGroup =>
            <FooterGroup footers={footerGroup.headers} {...footerGroup.getFooterGroupProps()} />,
          )
        }
      </div>
    );
  },
);

export default Footers;
